module.exports = __webpack_public_path__ + "img/glasses_female_round_mask.8b296ce8.png";